import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER } from '../../utils';

export const getLandingPagePath = ({ slug }) => {
    const params = { page_name: slug };

    return pathfinder(PATHFINDER.LANDING_PAGE, params);
};
